import { Component, createElement } from "rax";
import { registerComponent, renderComponent, ComponentRenderParameter } from "../../common/component-manager";
import { mtop, jsonp } from "../../common/fetchData";
import { getOffsetTop } from "../../common/utils";
import { FPEvent, FPModule, FPTabItemModule, FreePageModuleType, FPMtopResponse, appNativeComponentMap } from "../../models";
import TabItem from "./tab-item";
import DinamicCom from "../dinamic-com";
import TemplateDTO from "../../models/TemplateDTO";
import "./index.less";
interface Props {
  tabModuleList?: FPModule[]; // Tab 模块列表

  events?: FPEvent[]; // 单独指定 Events（Page 级别）

}
interface State {
  pageIndex: number; // 当前 page 页码

  selectedTabIndex: number; // 当前选中 Tab

  tabModuleList: FPTabItemModule[]; // Tab 信息

  events?: FPEvent[]; // 单独指定 Events（Page 级别）

  moduleList: FPModule[]; // 当前 Tab 的产品卡片列表

  templateURLMap: object; // 模版 name -> URL 映射

  end: boolean; // 是否加载完成

  isPageEvent: boolean; // 是否为 FP 页面级事件

}
export default class FPTabList extends Component<Props, State> {
  constructor(props) {
    super(props);
    const {
      tabModuleList,
      events
    } = props;
    const isPageEvent = events ? true : false;
    this.loading = false;
    this.state = {
      pageIndex: isPageEvent ? 1 : 0,
      // 页面级事件从第二页（pageIndex=1）开始请求（因为第一页已经首屏返回了）
      selectedTabIndex: 0,
      tabModuleList,
      events,
      moduleList: [],
      templateURLMap: {},
      end: false,
      isPageEvent
    };
  }

  componentDidMount(): void {
    this.loadData(this.state.pageIndex);
    let timer = null;
    window.addEventListener("scroll", () => {
      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(() => {
        timer = null;
        this.checkLoadMore();
      }, 60);
    });
  }

  checkLoadMore() {
    const y = window.scrollY || window.pageYOffset;
    const loadele = document.getElementById("loaddingDiv");
    const loadingOffsetTop = getOffsetTop(loadele); // console.log( loadingOffsetTop, y);

    if (y > 0 && loadingOffsetTop - y < 1000) {
      // console.log("开始下一页加载", this.state.pageIndex + 1);
      const newPageIndex = this.state.pageIndex + 1;
      this.loadData(newPageIndex, (moduleList, error) => {
        if (moduleList && moduleList.length > 0) {
          // this.state.pageIndex = newPageIndex; // page更新不及时，导致重新加载
          this.setState({
            pageIndex: newPageIndex
          });
        } else {
          this.setState({
            end: true
          });
        }
      });
    }
  }

  loadData(pageIndex: number, callback = (moduleList: FPModule[], error: boolean) => {}) {
    const {
      selectedTabIndex,
      tabModuleList,
      events,
      end
    } = this.state; // console.log(pageIndex, this.loading, end);

    if (this.loading || end) {
      return;
    }

    let event;

    if (tabModuleList) {
      const currentTabModule = tabModuleList[selectedTabIndex];
      event = currentTabModule.events[0];
    } else if (events) {
      event = events[0];
    }

    if (!event || !event.request) {
      if (callback) callback(null, false);
      return;
    } // console.log( "发请求：",pageIndex, this.loading, end);


    const params = { ...event.request.param,
      ...{
        pageIndex: pageIndex
      }
    }; // 增加PC的端型环境
    // let paramMap = {};
    // if (params.paramMap){
    //   paramMap = JSON.parse(params.paramMap);
    //   paramMap.env = "freepage_pc";
    //   paramMap.endpoint = "pc";
    //   params.paramMap = JSON.stringify(paramMap);
    // }

    this.loading = true;
    mtop({
      api: event.request.api,
      data: params,
      onSuccess: data => {
        const responseObj = (data as FPMtopResponse); // 缓存模版映射

        if (responseObj && responseObj.sharedTemplates) {
          for (const template of responseObj.sharedTemplates) {
            const {
              name,
              urlH5,
              url
            } = template;
            const templateUrl = urlH5 || url;

            if (name && templateUrl) {
              this.state.templateURLMap[name] = templateUrl;
            }
          }
        } // 解析楼层


        const {
          moduleList
        } = responseObj.body || {};

        if (moduleList && moduleList.length > 0) {
          if (pageIndex == 0) {
            this.setState({
              moduleList,
              end: false
            });
          } else {
            this.setState({
              end: moduleList.length < 20,
              moduleList: this.state.moduleList.concat(moduleList)
            });
          }
        } else {
          this.setState({
            end: true
          });
        }

        this.loading = false;
        if (callback) callback(moduleList, false); // console.log("请求成功返回", pageIndex, this.loading, end);
      },
      onError: () => {}
    });
  }

  render() {
    const {
      tabModuleList,
      moduleList,
      loading,
      end
    } = this.state;
    return <div className="fp-tab-list">
        {tabModuleList && <div className="header-hor-tabs">
            {tabModuleList.map((tab, index) => {
          return <TabItem key={index} title={tab.data["title"]} selected={index === this.state.selectedTabIndex} imageUrl={tab.data["imageUrl"]} onClick={() => {
            if (this.state.selectedTabIndex === index) return; // 更新当前选中 Tab

            this.loading = false;
            this.setState({
              selectedTabIndex: index,
              pageIndex: 0,
              moduleList: []
            }, () => {
              // 刷新列表数据
              this.loadData(0);
            });
          }} />;
        })}
          </div>}
        <div className="flexContainer">
          {moduleList.map((module, index) => {
          let {
            freeBlockTemplateName,
            type
          } = module;
          let templateURL: string = this.state.templateURLMap[freeBlockTemplateName]; // App 用的 Native Card 替换为对应 DX 模版

          if (type === FreePageModuleType.NativeCommonProductCard) {
            const replaceTemplateDTO = (appNativeComponentMap[FreePageModuleType.NativeCommonProductCard] as TemplateDTO);

            if (replaceTemplateDTO) {
              freeBlockTemplateName = replaceTemplateDTO.name;
              templateURL = replaceTemplateDTO.url;
            }
          }

          if (!module.data || !freeBlockTemplateName || !templateURL) {
            return;
          }

          let moduleColumn = module.modulePerLine || '1'; // PC列对应关系，强制写成5

          if (moduleColumn == 2) {
            moduleColumn = 5;
          }

          return <div key={index} className={`flexColFloor flex${moduleColumn}ColFloor`}>
                <DinamicCom data={module.data} templateDTO={{
              name: freeBlockTemplateName,
              url: templateURL
            }} />
              </div>;
        })}
        </div>
        <div id="loaddingDiv">
        {!end && <div class="loading" />}
        </div>
      </div>;
  }

}

function tabComponentRender({
  moduleWarp,
  containerElement
}: ComponentRenderParameter) {
  const data = (moduleWarp.data?.data as {
    moduleList: FPModule[];
  });
  const {
    moduleList
  } = data;
  containerElement.innerHTML = "";
  renderComponent(<FPTabList tabModuleList={moduleList} />, containerElement);
} // 注册组件：tab


registerComponent("tab", {
  render: tabComponentRender
});
registerComponent("tab_with_list", {
  render: tabComponentRender
}); // 注册组件：fp-list

registerComponent("fp-list", {
  render: ({
    fpPageEvents,
    containerElement
  }: ComponentRenderParameter) => {
    if (!fpPageEvents || fpPageEvents.length === 0) {
      return;
    }

    const containerEl = document.getElementById("fp-list");

    if (containerEl) {
      containerEl.innerHTML = "";
    }

    renderComponent(<FPTabList events={fpPageEvents} />, containerElement || containerEl);
  }
});